import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getMyAuctionsV3 } from '../../../api/bid';
import { Loader } from '../../../components/Loader';
import useFetch from '../../../hooks/useFetch';
import useInfiniteScroll from '../../../hooks/useInfiniteScroll';
import { Auction } from '../../../models/Auction';
import { useBidServiceContext } from '../../../providers/BidServiceProvider/BidServiceProvider';
import { DEFAULT_LIMIT } from '../../../shared/lib/const/limit';
import { BidTabs } from '../../../widgets/BidTabs';
import { AuctionCard } from '../AuctionCard/AuctionCard';

export const BidWinnings: React.FC = () => {
  const { t } = useTranslation(['translation']);
  const { myBidsData } = useBidServiceContext();
  const [page, setPage] = useState(1);
  const [auctions, setAuctions] = useState<Auction[]>([]);
  const targetRef = useRef<HTMLDivElement>(null);
  const hasFetched = useRef(false);
  const {
    data,
    isLoading: isLoadingAuctions,
    fetchData: fetchAuctions,
  } = useFetch(getMyAuctionsV3);

  const loadComments = useCallback(() => {
    if (data?.count && data?.count > page) {
      fetchAuctions(page + 1).then((res) => {
        setAuctions([...(auctions || []), ...(res?.results || [])]);
        res?.results.length === DEFAULT_LIMIT && setPage(page + 1);
      });
    }
  }, [auctions, data?.count, fetchAuctions, page]);

  useInfiniteScroll(targetRef, loadComments);

  useEffect(() => {
    hasFetched.current = false;
    fetchAuctions(page).then((res) =>
      setAuctions([...(auctions || []), ...(res?.results || [])])
    );
  }, [t]);

  return (
    <div className={'px-2 lg:px-0'}>
      <h1 className={'g-main-title mb-4 block lg:mb-6 lg-max:hidden'}>
        {t('menu.Winnings')}
      </h1>
      <BidTabs />
      {!!auctions?.length ? (
        <div className={'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'}>
          {auctions
            ?.filter((item) => Object.keys(myBidsData).includes(`${item?.id}`))
            .map((item) => (
              <AuctionCard key={item.id} data={item} status={item.status} />
            ))}
        </div>
      ) : null}
      {auctions?.length < (data?.count || 1) ? (
        <>
          <div ref={targetRef} className="mt-3" />
          {isLoadingAuctions ? <Loader /> : null}
        </>
      ) : null}
    </div>
  );
};
